// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__h5YvN","loaderbox":"style_loaderbox__vHK5d"};